import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApLoggingModule } from '@ap/logging';
import { ApCardComponent } from '@ap/card';

import { Auth0sessionComponent } from './auth0session.component';
/**
 * @ngdoc module
 * @name Auth0sessionModule
 */
@NgModule({
    declarations: [Auth0sessionComponent],
    imports: [ApButtonComponent, ApContentPipe, ApContentComponent, ApLoggingModule, CommonModule, ApCardComponent, BrowserModule],
    exports: [Auth0sessionComponent]
})
export class Auth0sessionModule {}
